import { WarningFilled } from '@ant-design/icons';
import cx from 'classnames';
import styles from './AccessDenied.module.less';
import { useTranslation } from 'react-i18next';

export default function AccessDeniedPage() {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <WarningFilled className={cx(styles.iconError, styles.icon)} />
      <div>
        <span className={styles.label}>{t('accessDeniedPage.Header')}</span>
      </div>
      <div>
        <span className={styles.subLabel}>{t('accessDeniedPage.Body')}</span>
      </div>
    </div>
  );
}
